import React from 'react'
import PropTypes from 'prop-types'

class SoftwareListContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      containerWidth: 0,
      list: props.data,
      trimLength: 0,
    }

    this.containerRef = React.createRef()
    props.data.map(label => this[label] = React.createRef())
  }

  measureListCapacity() {
    const list = this.props.data
    const containerWidth = this.state.containerWidth
    const placeholderWidth = 80 // 80 is the width required for text '+i more'
    let elementsCombinedWidth = 0
    const expendables = []

    list.map(label => {
      const elementWidth = this[label].current.offsetWidth

      elementsCombinedWidth += elementWidth

      if (elementsCombinedWidth + placeholderWidth > containerWidth) {
        const labelIndex = list.indexOf(label)
        if (labelIndex > -1) expendables.push(label)

        elementsCombinedWidth -= elementWidth // Decrease total elements width since element will be removed
      }
    })

    if (expendables.length > 0) this.truncateList(this.props.data, expendables)
  }

  truncateList(data, expendables) {
    const updatedList = data.filter(label => !expendables.includes(label))

    this.setState({
      list: updatedList,
      trimLength: expendables.length,
    })
  }

  componentDidMount() {
    this.setState({
      containerWidth: this.containerRef.current.offsetWidth,
    }, this.measureListCapacity)
  }

  render() {
    return (
      <ul className="job-list-item__labels" ref={this.containerRef}>
        {this.state.list.map((label) => {
          const softwareOption = this.props.withLinks && this.props.softwareFilterOptions
            ? this.props.softwareFilterOptions.find(option => option.label === label)
            : null
          const softwareSlug = softwareOption?.slug

          return (
            <li ref={this[label]} key={`job-label-${label}`}>
              {this.props.withLinks && softwareSlug ? (
                <a href={`/3d-modeling-jobs/browse/${softwareSlug}`} target="_blank">
                  <span className="label label--info">{label}</span>
                </a>
              ) : (
                <span className="label label--info">{label}</span>
              )}
            </li>
          )
        })}
        {this.state.trimLength > 0 && (
          <li className="job-list-item__more-tags">
            +{this.state.trimLength} more
          </li>
        )}
      </ul>
    )
  }
}

SoftwareListContainer.propTypes = {
  data: PropTypes.array,
  softwareFilterOptions: PropTypes.array,
  withLinks: PropTypes.bool,
}

SoftwareListContainer.defaultProps = {
  data: [],
  softwareFilterOptions: null,
  withLinks: false,
}

export default SoftwareListContainer
